import useTableData from "../../../../state/table/UseTableData";

const useExpandIcon = (rowId) => {
  const { tableState, onUpdateExpandedIds } = useTableData();

  const onIconClicked = (e) => {
    e?.preventDefault();
    e?.stopPropagation();

    if (rowId) {
      const newExpandedIds = tableState.expandedIds.includes(rowId)
        ? tableState.expandedIds.filter(id => id !== rowId)
        : [...tableState.expandedIds, rowId];

      onUpdateExpandedIds(newExpandedIds);
    }
  };

  return {
    isExpanded: tableState.expandedIds.some(id => id === rowId),
    onIconClicked
  };
};

export default useExpandIcon;